import React from "react";
import ReactDOM from "react-dom";
import { SWRConfig } from "swr";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import reportWebVitals from "./reportWebVitals";

import { Root } from "./pages/Root";

import { get } from "./api/get";

import "./styles/base.css";
import "./styles/variables.css";

const version = process.env.REACT_APP_VERSION?.replace("refs/tags/", "");

console.log("VERSION", version);

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    release: version,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <SWRConfig
      value={{
        dedupingInterval: 60 * 60 * 1000,
        fetcher: (categoryId: number, listId?: number) =>
          get(categoryId, listId),
        onError: (err, key, config) => {
          console.log(err, key, config);
        },
      }}
    >
      <Root />
    </SWRConfig>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
